import React from "react"

import Popover from "../../../../core/gd-components/gd-popover/popover-v2"
import PopoverPosition from "../../../../core/gd-components/gd-popover/popover-position"
import {PopoverAttachmentType} from "../../../../core/gd-components/gd-popover/@const"
import {findDOMNode} from "react-dom"
import TopNavigationQuickSearch from "./model/quick-search"
import QuickSearch_SearchResults from "../../../../app/search/quick/components/search-results/search-results"

type Props = {
    className?  : string

    quickSearch : TopNavigationQuickSearch
}


// const debug = "NavigationPanel_QuickSearchResults"
const debug = false

export default class NavigationPanel_QuickSearchResults extends React.Component<Props, any> {

    constructor(props: Props) {
        super(props)

        props.quickSearch.componentResults = this
    }

    onClickOutside = (e: MouseEvent) => {
        debug && console.log(debug, "onClickOutside()")

        // there is no mouse event on gd.layout.popovers.closeAll()
        if(e) {
            if(gd.utils.Dom.findNodeByClassName(e.target, this.props.quickSearch.outsideClickIgnoreClasses)) {
                return
            }

            if (this.props.quickSearch.isSettingsPopoverShown) {
                return
            }
        }

        this.props.quickSearch.cancel()
    }

    public reRender = () => {

        debug && console.log(debug, "reRender()")

        this.forceUpdate()
    }

    render() {
        debug && console.log(debug, "render()")

        if (!this.props.quickSearch.searchEnabled) {
            return null
        }

        const popoverPosition = new PopoverPosition({
            attachment      : "top center",
            targetAttachment: "bottom center",
            targetOffset    : "-2 0",
            attachmentType  : PopoverAttachmentType.FULL,
        })

        return (
            <Popover popoverClass             = "w-700"
                     position                   = {popoverPosition}
                     onClickOutside             = {this.onClickOutside}
                     clickOutsideDelay          = {0}
                     outsideClickIgnoreClass    = "search"
                     getTargetFunc              = {() => findDOMNode(this)}>
                <QuickSearch_SearchResults containerClass   = "max-h-600 p-20"
                                           quickSearch      = {this.props.quickSearch}
                                           skipAutoRegister = {true} />
            </Popover>
        )
    }
}
